/**
 * UI elements
 */
class PWSJO_UI {
    constructor() {
        this.initSmoothScroll();
        this.initTextAccordion();
        this.initFileExtension();
        this.initFullScreenMap();
        this.initScrollBox();
        this.initChangeFontSize();
        this.initFocusKeyboard();
        this.initResponsiveTable();
        this.initMenuLink();
        this.initClipboardSupport();
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                }
            }
        });
    }

    initTextAccordion () {
        $(".accordion-item").each(function(i, item) {
            $(item).find('.accordion-item-content').css('height', 0);
            $(item).removeClass('not-initialized');

            $(item).on("click", function () {
                var item = $(this);
                var contentWrapper = item.find('.accordion-item-content');
                var contentText = item.find('.accordion-item-text');

                item.toggleClass('active');
                var newHeight = contentText.outerHeight();

                if (item.hasClass('active')) {
                    contentWrapper.css('height', 0);

                    setTimeout(function() {
                        contentWrapper.css('height', newHeight + 'px');
                    }, 0);

                    setTimeout(function() {
                        contentWrapper.css('height', 'auto');
                    }, 500);
                } else {
                    contentWrapper.css('height', newHeight + 'px');

                    setTimeout(function() {
                        contentWrapper.css('height', 0);
                    }, 0);
                }
            });
        });
    }

    initFileExtension () {
        $('.wp-block-file').each(function(i, item) {
            let wpLink = $(item);
            let fileLink = $(item).find('a');
            let fileLinkUrl = fileLink.attr('href');
            let fileExtension = fileLinkUrl.split('.').pop();

            if (fileExtension === 'pdf') {
                wpLink.addClass('is-pdf');
            } else if (fileExtension === 'xml' || fileExtension === 'xlsx' || fileExtension === 'xlsm' || fileExtension === 'xls' || fileExtension === 'numbers') {
                wpLink.addClass('is-xls');
            } else if (fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'rtf' || fileExtension === 'txt') {
                wpLink.addClass('is-doc');
            } else {
                wpLink.addClass('is-other');
            }
        });
    }

    initFullScreenMap () {
        let sectionMap = $('.block-map');
        let btnFullScreen = sectionMap.find('.fullscreen');
        let map = sectionMap.find('.gm-style');

        if (sectionMap.length) {
            btnFullScreen.click(function(e) {
                e.preventDefault();
                console.log('hi');
                sectionMap.find('div.gm-style button.gm-fullscreen-control').trigger('click');
            });
        }
    }

    initScrollBox () {
        const container = document.querySelector('.scroll-box');

        if (container !== null) {
            const ps = new PerfectScrollbar(container);
            container.scrollTop = 0;
        }
    }

    initChangeFontSize () {
        let htmlTag = $('html');
        let accessibilityBlock = $('.accessibility-block');
        let accessibilityBtnRegular = accessibilityBlock.find('button.small-font');
        let accessibilityBtnLarge = accessibilityBlock.find('button.large-font');
        let accessibilityBtnHuge = accessibilityBlock.find('button.huge-font');

        accessibilityBtnRegular.click(function(e) {
            htmlTag.removeClass('large-font');
            htmlTag.removeClass('huge-font');
        });

        accessibilityBtnLarge.click(function(e) {
            htmlTag.addClass('large-font');
            htmlTag.removeClass('huge-font');
        });

        accessibilityBtnHuge.click(function(e) {
            htmlTag.removeClass('large-font');
            htmlTag.addClass('huge-font');
        });
    }

    initFocusKeyboard () {
        let htmlTag = $('html');
        let selectWrapper = $('.select-wrapper');
        let selectLang = selectWrapper.find('.select-language');

        $('body').mousedown( function() {
            htmlTag.addClass('mouse');
            htmlTag.removeClass('keyboard');
            htmlTag.attr('data-whatintent', 'mouse');

            if (selectWrapper.length) {
                selectLang.attr("size", '');
            }
        });
          
        $('body').keydown( function(e) {
            if (e.keyCode === 9) {
                htmlTag.addClass('keyboard');
                htmlTag.removeClass('mouse');
                htmlTag.attr('data-whatintent', 'keyboard');

                if (selectWrapper.length) {
                    let selectOptions = selectLang.find('option');

                    selectLang.focus(function(e) {
                        selectLang.attr("size", selectOptions.length);
                    });

                    selectLang.blur(function(e) {
                        selectLang.attr("size", '');
                    });
                }
            }
        });
    }

    initResponsiveTable () {
        let tablepressTable = $('.tablepress');
        tablepressTable.wrap( "<div class='tablepress-wrapper'></div>" );
    }

    initMenuLink () {        
        $('.menu-item.title').each(function(i, item) {
            let menuTitleLink = $(item).find('a').eq(0);
            let menuTitleLinkAttr = menuTitleLink.attr('href');

            if(menuTitleLinkAttr !== undefined) {
                $(item).addClass('has-link');
            }
        });
    }

    initClipboardSupport () {
        if (!$('.copy-text').length) {
            return;
        }

        let clipboardInstance = new ClipboardJS('.copy-text', {
            text: function() {
                let textToCopy = $('.text-to-copy');
                let output = '';
                
                if (textToCopy.length) {
                    output = textToCopy.text().trim();
                }
                
                return output.replace(/(\n){3,}/gmi, "\n\n").trim();
            }
        });

        clipboardInstance.on('success', function(e) {
            $(e.trigger).text($(e.trigger).attr('data-copied-text'));
            $(e.trigger).addClass('is-success');
            e.clearSelection();

            setTimeout(() => {
                $(e.trigger).text($(e.trigger).attr('data-copy-text'));
                $(e.trigger).removeClass('is-success');
            }, 2000);
        });
    }
}